import { getStripePublishableKey, VENDOR_DISPLAY_NAMES } from "../../anyspend/constants/index.js";
import { loadStripe } from "@stripe/stripe-js";
// Cache Stripe promises per publishable key (supports multiple partners)
const stripePromiseCache = new Map();
/**
 * Get or create a Stripe promise for the given publishable key.
 * @param stripePublishableKey - Partner-specific Stripe publishable key from B3Provider
 */
export function getStripePromise(stripePublishableKey) {
    const publishableKey = getStripePublishableKey(stripePublishableKey);
    let cached = stripePromiseCache.get(publishableKey);
    if (!cached) {
        cached = loadStripe(publishableKey);
        stripePromiseCache.set(publishableKey, cached);
    }
    return cached;
}
export function getVendorDisplayName(vendor) {
    switch (vendor) {
        case "coinbase":
            return VENDOR_DISPLAY_NAMES.coinbase;
        case "stripe":
        case "stripe-web2":
            return VENDOR_DISPLAY_NAMES.stripe;
        default:
            return VENDOR_DISPLAY_NAMES.unknown;
    }
}
export function getPaymentMethodDescription(vendor) {
    switch (vendor) {
        case "stripe":
        case "stripe-web2":
            return "card, Apple Pay, Google Pay, and more";
        case "coinbase":
            return "debit card, or using your Coinbase account";
        default:
            return "supported payment method";
    }
}
export function formatStripeAmount(amount) {
    return (amount / 100).toFixed(2);
}
export function generateReturnUrl(orderId) {
    return `${window.location.origin}?orderId=${orderId}&waitingForDeposit=true`;
}
